import image1 from "../assets/red-list.webp";
import image2 from "../assets/blue-list.webp";
import image3 from "../assets/black-list.jpg";
import image4 from "../assets/double-list.webp";
import image5 from "../assets/gold-list.webp";
import image6 from "../assets/green-list.webp";
import image7 from "../assets/years18-list.webp";
import image8 from "../assets/georgeV-list.webp";
import image9 from "../assets/blonde-list.webp";
import image10 from "../assets/rabbit-list.webp";
import image11 from "../assets/bluelimited-list.webp";
import image12 from "../assets/lunar-list.webp";
import image13 from "../assets/redlimited-list.webp";
import image14 from "../assets/blacklimited-list.webp";
import image15 from "../assets/goldlimited-list.webp";
import image16 from "../assets/legendary-list.webp";
import image17 from "../assets/celebratory-list.webp";
import image18 from "../assets/bicentenary-list.webp";
import image19 from "../assets/icons-list.webp";

const selection = [
  {
    id: 0,
    name: "johnnie walker black label 12 years",
    image: image3,
    link: "",
  },
  {
    id: 1,
    name: "johnnie walker blue label",
    image: image2,
    link: "j",
  },
  {
    id: 2,
    name: "ohnnie walker red label",
    image: image1,
    link: "",
  },
  {
    id: 3,
    name: "johnnie walker gold label reserve",
    image: image5,
    link: "",
  },
  {
    id: 4,
    name: "johnnie walker double black",
    image: image4,
    link: "",
  },
  {
    id: 5,
    name: "johnnie walker green label 15 years",
    image: image6,
    link: "",
  },
  {
    id: 6,
    name: "johnnie walker aged 18 yyears",
    image: image7,
    link: "",
  },
  {
    id: 7,
    name: "johnnie walker king george v",
    image: image8,
    link: "",
  },
  {
    id: 8,
    name: "johnnie blonde",
    image: image9,
    link: "",
  },
  {
    id: 9,
    name: "johnnie walker blue label yars of the rabbit",
    image: image10,
    link: "",
  },
  {
    id: 10,
    name: "johnnie walker blue label limited edition",
    image: image11,
    link: "",
  },
  {
    id: 11,
    name: "johnnie walker king george V lunar new year",
    image: image12,
    link: "",
  },
  {
    id: 12,
    name: "johnnie walker red label limited edition",
    image: image13,
    link: "",
  },
  {
    id: 13,
    name: "johnnie walker black label limited edition",
    image: image14,
    link: "",
  },
  {
    id: 14,
    name: "johnnie walker gold label limited edition",
    image: image15,
    link: "",
  },
  {
    id: 15,
    name: "johnnie walker blue label legendary eight",
    image: image16,
    link: "",
  },
  {
    id: 16,
    name: "johnnie walker celebratory blend",
    image: image17,
    link: "",
  },
  {
    id: 17,
    name: "johnnie walker bicentenary blend",
    image: image18,
    link: "",
  },
  {
    id: 18,
    name: "johnnie walker icons limited edition",
    image: image19,
    link: "",
  },
];

export default selection;
